import type { ConfigType } from '@plone/registry';
import installSettings from './config/settings';
import installHomepageAsyncProps from './config/homepageAsyncProps';
import installViews from './config/views';
import installRoutes from './config/routes';
import installBlocks from './config/blocks';
import installServer from './config/server';
import { installBreadcrumbPathGuard } from './config/breadcrumbPathGuard';
import installDsgvo from './config/dsgvo';
import CSJTags from './customizations/components/theme/Tags/Tags';
import FontPreloads from './components/theme/FontPreloads';

function applyConfig(config: ConfigType) {
  installSettings(config);
  installHomepageAsyncProps(config);
  installViews(config);
  installRoutes(config);
  installBlocks(config);
  installServer(config);

  config.registerSlotComponent({
    slot: 'belowContent',
    name: 'tags',
    component: CSJTags,
  });

  // Avoid GET_CONTENT navigation expander overwriting header nav on language switch.
  // Fetch breadcrumbs via @breadcrumbs on route change (pre SPA stale trail fix).
  config.settings.apiExpanders = (config.settings.apiExpanders || [])
    .filter((expander) => !expander.GET_CONTENT?.includes('navigation'))
    .map((expander) => {
      if (!expander.GET_CONTENT?.includes('breadcrumbs')) {
        return expander;
      }
      return {
        ...expander,
        GET_CONTENT: expander.GET_CONTENT.filter(
          (item) => item !== 'breadcrumbs',
        ),
      };
    });

  config.settings.appExtras = [
    ...(config.settings.appExtras || []),
    { match: '', name: 'csj-font-preloads', component: FontPreloads },
  ];

  installBreadcrumbPathGuard(config);

  installDsgvo(config);

  return config;
}

export default applyConfig;
